import { Injectable } from '@angular/core';
import { CtNavbarComponent } from '../controls';

@Injectable({
  providedIn: 'root'
})
export class NavbarService {
  private navbarComponent : CtNavbarComponent;

  constructor() { }

  setNavbarComponent(navbarComponent : CtNavbarComponent) {
    this.navbarComponent = navbarComponent;
  }

  toggleHelpMenu(): void {
    this.navbarComponent.toggleHelpMenu();
  }
}
